module.exports = __webpack_public_path__ + "static/media/jed.816e244c.png";